import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { DataService } from '../../services/data.service';
import { SiteService } from '../../services/site.service';
import { getQueryParamFromAncestorRoute } from '../../utilities/route.utilities';
import { MasonryItemModel } from '../masonry/masonry.component';
import { IssuesHighConsumptionComponent } from './grid-item/metering/issues-high-consumption-grid-item.component';
import { IssuesLowConsumptionComponent } from './grid-item/metering/issues-low-consumption-grid-item.component';
import { IssuesNoConsumptionComponent } from './grid-item/metering/issues-no-consumption-grid-item.component';
import { IssuesReadDataAvailabilityConsumptionComponent } from './grid-item/metering/issues-read-data-availability-consumption-grid-item.component';
import { IssuesRecentDeadDataConsumptionComponent } from './grid-item/metering/issues-recent-read-data-consumption-grid-item.component';

@Component({
    selector: 'issues-metering',
    templateUrl: './issues-metering.component.html'
})

export class IssuesMeteringComponent implements OnInit, OnDestroy {

    masonryItems: MasonryItemModel[] = [];
    subscriptions: Subscription[] = [];
    clientId: number;
    selectedSiteId: number = 0;
    userSiteId: number = 0;
    sites: any[] = [];

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
        private router: Router,
        private siteService: SiteService
    ) { }

    ngOnInit() {
        this.masonryItems = [
            {
                component: IssuesLowConsumptionComponent,
                isExpandable: true
            },
            {
                component: IssuesHighConsumptionComponent,
                isExpandable: true
            },
            {
                component: IssuesNoConsumptionComponent,
                isExpandable: true
            },
            {
                component: IssuesRecentDeadDataConsumptionComponent,
                isExpandable: true
            },
            {
                component: IssuesReadDataAvailabilityConsumptionComponent,
                isExpandable: true
            }
        ];

        //update isExpandable per item, if data is resolved
        this.dataService.issuesLowConsumptionComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesLowConsumptionComponent).isExpandable = result
        )

        this.dataService.issuesHighConsumptionComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesHighConsumptionComponent).isExpandable = result
        )

        this.dataService.issuesNoConsumptionComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesNoConsumptionComponent).isExpandable = result
        )

        this.dataService.issuesRecentReadDataComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesRecentDeadDataConsumptionComponent).isExpandable = result
        )

        this.dataService.issuesReadDataAvailabilityComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesReadDataAvailabilityConsumptionComponent).isExpandable = result
        )


        this.userSiteId = parseInt(getQueryParamFromAncestorRoute(this.route, 'siteId'));

        this.subscriptions.push(this.route
            .parent!
            .parent!
            .params
            .subscribe(params => {
                this.clientId = +params['clientId'];
                this.search();
            }));

        if (Number.isNaN(this.userSiteId) || this.userSiteId === undefined) { this.userSiteId = 0; }

        this.selectedSiteId = this.userSiteId;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    search() {
        this.siteService.all(this.clientId).then((result) => {
            this.sites = result;
            this.selectedSiteId
        });
    }

    updateSite() {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        if (this.selectedSiteId != undefined && this.selectedSiteId != null) {
            queryParams.siteId = +this.selectedSiteId;
        }
        this.router.navigate(['/portal/' + this.clientId.toString() + '/issues/metering'], {
            queryParams: queryParams,
            replaceUrl: true
        }).then(result => {
            this.ngOnDestroy();
            this.ngOnInit();
        });
    }
}
